import type { MedicalTechnologyIdType } from '@app/icare/entities/medicalTechnology/schema/MedicalTechnology'
import { ContactPersonTable } from '@app/icare/routes/_app/apotheken/-components/ContactPersonTable'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/medizintechnik/$id/contact-persons')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ContactPersonTable ownerId={Route.useParams().id as MedicalTechnologyIdType} />
}
